module.exports = __webpack_public_path__ + "assets/14b3ef6d99c81bf343640fe0d8fe7f6f.png";